import * as React from "react"
import { useEffect } from "react"
import { batch } from "@preact/signals-react"
import { disabledAfter } from "@ui-seeker/core"
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import { COMMON_FILTER_KEYS, STOCK_ROUTES, YESTERDAY_DATE } from "@constants"
import { useAppDefaultFilters } from "@hooks"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { elementsInLoading, stockAssDetailsIsEmpty, stockAssDetailsSummaryClickFilters } from "./@signals"


export default function StockAssortmentDetailsFilters() {

    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(STOCK_ROUTES.STOCK_ASSORT_ID, STOCK_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    useEffect(() => {
        if (elementsInLoading.value.length < 1) {
            isLoadingCommonFilters.value = false
        }
    }, [elementsInLoading.value])

    return <Box data-tour="assdetails-filters">
    <CommonFilters
        components={{
            country: true, site: true,
            category: true, brand: true,
            sku: true, favFilters: true,
            skuGroup: true, onlySingleDate: true,
            productsInStock: true
        }}
        compProps={{
            country: { disableClearable: true },
            sku: { grid: { md: 6 } },
            favFilters: {
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.PRODUCTS_IN_STOCK
                ],
                dashboardKey: STOCK_ROUTES.STOCK_ASSORT_ID,
            },
            spaceOnlySingleDate: { grid: { xs: 0, md: 0 } },
            currentPrevDates: {  shouldDisableDate: disabledAfter(YESTERDAY_DATE) },
            productsInStock: { grid: { md: 5 } },
        }}
        onSubmit={() => {
            batch(() => {
                stockAssDetailsIsEmpty.value = false
                isSystemBusy.value = false
                stockAssDetailsSummaryClickFilters.value = {}
                isLoadingCommonFilters.value = true
            })
        }}
        defaultValues={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}